export const CLEAR_ORGANIZATION_MODULE = 'organizations:CLEAR_ORGANIZATION_MODULE'

export const FETCH_ORGANIZATION = 'organizations:FETCH_ORGANIZATION'
export const FETCH_ORGANIZATION_SUCCESS = 'organizations:FETCH_ORGANIZATION_SUCCESS'
export const FETCH_ORGANIZATION_FAILURE = 'organizations:FETCH_ORGANIZATION_FAILURE'
